<template>
	<section
		id="portfolioMap"
		class="portfolio_map bg-white will-change relative z-[1]"
		:data-scroll-section="inner == 'false'"
	>
		<h2
			class="text-4xl xl:text-heading text-center mb-8 px-content w-full"
			:class="{ 'pt-10 xl:pt-20': blockData.title }"
			v-if="blockData.title"
			v-html="blockData.title"
		></h2>
		<div class="mx-content relative h-[67vh]">
			<!-- map -->
			<div id="map" class="rounded-lg" style="height: 100%"></div>
			<!-- map -->

			<div
				class="absolute bottom-8 left-1/2 -translate-x-1/2 bg-white bg-opacity-90 rounded text-xs text-center px-10 py-5 whitespace-nowrap"
			>
				<span>{{
					__("Click on the interest point or zoom in to view more", "ccave")
				}}</span>
			</div>

			<div class="flex items-center" ref="popup">
				<div v-if="activePortfolio" class="flex mr-auto items-start flex-col">
					<div
						class="flex gap-2 items-center text-lg font-bold text-navy-blue-02 py-4 px-3"
					>
						<img
							:src="activePortfolio.portfolio[0].fields.country_flag.url"
							:alt="activePortfolio.portfolio[0].fields.country_flag.alt"
						/>
						{{ activePortfolio.country_name }}
					</div>

					<div
						v-for="(p, index) in filteredPlaces"
						:key="index"
						class="cursor-pointer flex items-center border-t border-light-grey text-sm text-navy-blue-02 p-3"
						@click.stop.prevent="showPlaceSlide(p)"
					>
						<div>{{ p.title }}</div>

						<svg
							class="ml-auto"
							width="16"
							height="16"
							viewBox="0 0 16 16"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M6 3L11 8L6 13"
								stroke="#808F98"
								stroke-width="1.2"
								stroke-linecap="square"
							/>
						</svg>
					</div>
				</div>
			</div>
		</div>

		<div
			:class="{
				'xyz-in z-[51] active-card': showSlide,
				'xyz-out z-[40]': !showSlide,
			}"
			class="card-toponyms--slide fixed right-0 top-0 bottom-0 z-[51] flex flex-col bg-white shadow-md w-full sm:w-[504px] h-[calc(100vh-66px)] xl:h-[calc(100vh-116px)] overflow-y-auto invisible"
			xyz="fade right-100% duration-4"
			ref="slideCard"
			data-scroll
			data-scroll-sticky
			data-scroll-target="#portfolioMap"
			v-on-clickaway="clickAwaySlide"
		>
			<button
				type="button"
				@click="hidePlaceSlide()"
				class="grid place-items-center bg-mid-grey rounded-full cursor-pointer hover:opacity-70 w-10 h-10 absolute right-4 top-10"
			>
				<svg
					xmlns="http://www.w3.org/2000/svg"
					class="h-6 w-6"
					fill="none"
					viewBox="0 0 24 24"
					stroke="white"
				>
					<path
						stroke-linecap="round"
						stroke-linejoin="round"
						stroke-width="1"
						d="M6 18L18 6M6 6l12 12"
					/>
				</svg>
			</button>
			<div class="pb-10 h-full" v-if="activePlace">
				<div class="overflow-hidden h-[34vh]">
					<img
						class="object-cover w-full"
						:src="activePlace.image.sizes.customslide"
						:alt="activePlace.image.alt"
					/>
				</div>

				<div class="p-8">
					<div
						class="text-xs tracking-little text-navy-blue-03 mb-3"
						v-html="activePlace.location"
					></div>
					<h4
						class="text-2xl tracking-[1px] mb-5"
						v-html="activePlace.title"
					></h4>
					<div
						class="text-sm text-dark-grey leading-[1.42]"
						v-html="activePlace.text"
					></div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
import mapboxgl from "mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";
import { mixin as clickaway } from "vue-clickaway";

export default {
	name: "PortfolioMap",
	mixins: [clickaway],
	data() {
		return {
			map: false,
			popup: false,
			activePortfolio: false,
			activePlace: false,
			activeFillIndex: false,
			showSlide: false,
			clickLocked: false,
		};
	},
	computed: {
		filteredPlaces() {
			if (!this.activePortfolio) return [];
			const places = this.activePortfolio.portfolio[0]?.fields?.places || [];
			return places.filter((p) => p && p.title);
		},
	},
	mounted() {
		mapboxgl.accessToken = this.blockData.map.map_settings.access_token;
		this.map = new mapboxgl.Map({
			container: "map",
			style: "mapbox://styles/aleksandarstojsin/ckvqetdww39pn14pd9wi9smdp",
			center: this.blockData.map.map_settings.center,
			zoom: this.blockData.map.map_settings.zoom,
			pitch: this.blockData.map.map_settings.pitch,
			bearing: this.blockData.map.map_settings.bearing,
			cooperativeGestures: true,
			attributionControl: false,
		});

		this.popup = new mapboxgl.Popup({
			closeButton: false,
			closeOnClick: true,
		});

		this.map.on("load", () => {
			const countries = this.blockData.map.markers.map(
				(el) => el.country_map_selector
			);

			this.$http
				.get(
					this.endpoints.rest_base_endpoint +
						"lustica/v1/get_geojson_country_data",
					{ params: { countries } }
				)
				.then((res) => {
					this.blockData.map.markers.forEach((marker, index) => {
						this.blockData.map.markers.forEach((marker, index) => {
						});
						const marker_data = res.data.data[marker.country_map_selector];
						this.map.addSource("polygon" + index, {
							type: "geojson",
							data: marker_data,
						});

						const point_data = JSON.parse(marker.map_data);
						this.map.addSource("point" + index, {
							type: "geojson",
							data: point_data,
						});

						this.map.addLayer({
							id: "fill" + index,
							type: "fill",
							source: "polygon" + index,
							paint: {
								"fill-color": "#001E31",
								"fill-opacity": 1,
							},
						});

						this.map.addLayer({
							id: "text" + index,
							type: "symbol",
							source: "point" + index,
							layout: {
								"text-field": marker.country_name,
								"text-font": ["Open Sans Semibold", "Arial Unicode MS Bold"],
								"text-offset": this.getLabelAnchor(marker.country_name_position)
									.offset,
								"text-anchor": this.getLabelAnchor(marker.country_name_position)
									.anchor,
								"text-justify": this.getLabelAnchor(
									marker.country_name_position
								).justify,
							},
							paint: { "text-color": "#001E31" },
						});

						// use reusable method
						this.map.on("click", "fill" + index, (e) => {
							this.selectCountry(e, marker, index);
						});

						this.popup.on("close", () => {
							this.map.setPaintProperty(
								"fill" + index,
								"fill-color",
								"#001E31"
							);
						});
					});
				});
		});

		this.map.addControl(new mapboxgl.NavigationControl());
		this.map.scrollZoom.disable();
	},
	watch: {
		showSlide(val) {
			if (val) {
				this.$root.scroll.stop();
			} else {
				this.$root.scroll.start();
			}
		},
	},
	methods: {
		// ensures Vue updates DOM before popup mounts
		selectCountry(e, marker, index) {
			if (this.clickLocked) return;
			this.clickLocked = true;
			setTimeout(() => {
				this.clickLocked = false;
			}, 500);

			this.activePortfolio = { ...marker };
			this.showSlide = false;
			this.map.setPaintProperty("fill" + index, "fill-color", "#B7E4F8");
			this.activeFillIndex = index;

			this.$nextTick(() => {
				this.popup
					.setLngLat(e.lngLat)
					.setDOMContent(this.$refs.popup)
					.addTo(this.map);
			});
		},
		clickAwaySlide() {
			this.showSlide = false;
		},
		getLabelAnchor(position) {
			if (position == "Top")
				return { anchor: "center", justify: "center", offset: [0, -2.5] };
			if (position === "Bottom")
				return { anchor: "center", justify: "center", offset: [0, 2.5] };
			if (position === "Left")
				return { anchor: "left", justify: "left", offset: [2.5, 0] };
			if (position === "Right")
				return { anchor: "right", justify: "right", offset: [-2.5, 0] };
		},
		showPlaceSlide(place) {
			if (
				this.$refs.slideCard.classList.contains("invisible") &&
				!this.showSlide
			) {
				this.activePlace = place;
				this.$refs.slideCard.style.visibility = "visible";
				this.showSlide = true;
				this.popup.remove();

				const offsetCard = this.$root.isMobile ? -67 : -116;

				this.$root.scroll.scrollTo("#portfolioMap", {
					offset: offsetCard,
					duration: 800,
					disableLerp: true,
				});
			}
		},
		hidePlaceSlide() {
			setTimeout(() => {
				this.$refs.slideCard.style.visibility = "hidden";
			}, 500);
			this.showSlide = false;
		},
	},
};
</script>

<style scoped>
.map {
	position: absolute;
	left: 33.3333%;
	width: 66.6666%;
	top: 0;
	bottom: 0;
}
</style>
